<template>
  <div
    class="flash-message-list"
    data-test="FlashMessageList"
  >
    <TransitionGroup
      appear
      name="fade"
    >
      <div
        class="font-pp-mori mb-4 flex items-stretch rounded-none border"
        :class="alert.colorClass === 'invalid'
          ? 'border-[#D9D1CE] bg-white'
          : 'border-[#E1A84E] bg-[#FABB5C]'"
        :data-test="`FlashMessage${capitalizeFirstLetter(alert.colorClass)}`"
        :key="alert.id"
        v-for="alert in notifications"
      >
        <p class="font-regular flex-1 p-4 text-sm text-[#281912]">{{ alert.message }}</p>
        <button
          @click="hideNotification(alert.id)"
          class="flex items-center px-4 text-[#281912] hover:bg-black/10"
          :class="alert.colorClass === 'invalid' ? 'border-l border-[#D9D1CE]' : 'border-l border-[#E1A84E]'"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { useMessagesStore } from '@/store/useMessagesStore';

import { capitalizeFirstLetter } from '@freelancerepublik/helpers';

const messagesStore = useMessagesStore();

defineProps<{
  notifications: Array<any>;
}>();

function hideNotification(id) {
  messagesStore.popFlashMessage(id);
}
</script>

<style lang="scss" scoped>
.flash-message-list {
  position: fixed;
  bottom: 10px;
  width: auto;
  max-width: 400px;
  z-index: 999;
  right: 20px;

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
}
</style>
